// removed by extract-text-webpack-plugin
module.exports = {"smBreak":"600px","mdBreak":"960px","unit":"5px","oldColorViolet":"#652c91","shadeDisabled":"rgb(205, 204, 204)","caption":"fonts__caption____HpZ4e","bold":"fonts__bold____2QXwg","h6":"fonts__h6____3ulj6","header":"section-accordion__header____32L9B fonts__h6____3ulj6","icon":"section-accordion__icon____2vkw2","heading":"section-accordion__heading____lGg8E","title":"section-accordion__title____jNtbg fonts__bold____2QXwg","expander":"section-accordion__expander____vdHr3","expanderLabel":"section-accordion__expanderLabel____2wTT8 fonts__bold____2QXwg"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/section-accordion/section-accordion.css
// module id = 685
// module chunks = 0